import {attachYmaps3React} from './attachYmaps3React'
import {MapsContextLoadedValue} from './context'
import {Maps} from './types'

const API_KEY = '0e09d1be-3b8d-44b4-9d0e-eb3a3fd93aea'
const getUrl = ({lang}: {lang: string}) => `https://api-maps.yandex.ru/3.0/?apikey=${API_KEY}&lang=${lang}`

const loadScript = (url: string) =>
  new Promise((resolve, reject) => {
    const script = document.createElement('script')

    script.onload = resolve
    script.onerror = reject
    script.src = url

    document.body.appendChild(script)
  })

let loadPromise: Promise<MapsContextLoadedValue>

type LoadYmapsApiProps = {
  lang: string
}

export const loadYmapsApi = ({lang}: LoadYmapsApiProps) => {
  if (!loadPromise) {
    loadPromise = new Promise<Maps>((resolve, reject) => {
      loadScript(getUrl({lang}))
        .then(() => {
          ymaps3 ? ymaps3.ready.then(() => resolve(ymaps3)) : reject('ymaps3 not defined')
        })
        .catch(reject)
    }).then(res => attachYmaps3React(res).then(components => ({loaded: true, components, ymaps3: res, lang})))
  }

  return loadPromise
}
